import { NgModule } from '@angular/core';
import { CommonModule } from 'app/common.module';
import { InfopostNavContainerComponent } from './infopost-nav-container.component';
import { HeaderModule } from '../header/header.module';
import { InfoPostSidenavBarModule } from './sidebar-nav/sidenav-bar.module';
import { NavContainerModule } from '../nav-container/nav-container.module';
import { LoadingSpinnerModule } from 'shared/components/loading-spinner/loading-spinner.module';
import { ErrorPanelModule } from 'shared/components/error-panel/error-panel.module';

@NgModule({
    declarations: [
        InfopostNavContainerComponent
    ],
    imports: [
        CommonModule,
        HeaderModule,
        InfoPostSidenavBarModule,
        NavContainerModule,
        LoadingSpinnerModule,
        ErrorPanelModule
    ],
    exports: [
        InfopostNavContainerComponent
    ]
})
export class InfopostNavContainerModule { }
